'use client';

import React from 'react';
import { Paper, Title, Text } from '@mantine/core';

interface EmailComposerProps {
  templates: string[];
  onSend: (email: any) => Promise<void>;
}

export function EmailComposer({ templates, onSend }: EmailComposerProps) {
  return (
    <Paper shadow="sm" radius="md" p="lg">
      <Title order={4}>Email Composer</Title>
      <Text c="dimmed" size="sm">Email composer coming soon</Text>
    </Paper>
  );
}